export const enPendingSchedules = {
	title: "Pending Schedules",
	description: "Please decide what to do with each campaign sender before removing.",
	cancel: "Cancel",
	reassign: "Reassign",
	doNothing: "Do nothing",
	fromSender: "From Sender",
	cancelAll: "Cancel All",
	reassignAll: "Reassign All",
	campaign: "Campaign",
	list: "List",
	pending: "Pending",
	action: "Action",
	sender: "Sender",
	addToCampaign: "Add sender to campaign",
	deleteSenderAndApply: "Remove Sender & Apply",
	migrationLevel: "Migration Level",
	migrationLevelDescription:
		"Choose which leads should be reassigned based on their progress in the sequence.",
	safe: "Safe Migration",
	safeDescription:
		"Only leads that have not started any steps yet. Zero risk of duplicate outreach.",
	safeBadge: "Recommended",
	silent: "Silent Migration",
	silentDescription:
		"Leads whose only executed steps were invisible (profile visits). The lead has not seen any communication.",
	silentBadge: "No Risk",
	forced: "Forced Migration",
	forcedDescription:
		"All active leads regardless of progress. May cause duplicate outreach if leads have already received messages.",
	forcedBadge: "Risk",
	resetRuleTitle: "Reset Rule",
	resetRuleDescription:
		"All reassigned leads will restart at Step 1 under the new sender. Existing step history is preserved for audit purposes.",
	forcedWarning:
		"Warning: Forced migration will reassign leads that have already received messages. This may result in duplicate outreach from the new sender.",
	forcedConfirmTitle: "Confirm Forced Migration",
	forcedConfirmDescription:
		"You are about to force-migrate leads that may have already received messages. This can cause duplicate outreach. Are you sure you want to proceed?",
	forcedConfirmButton: "Yes, Force Migrate",
};
